import WebApp from '@twa-dev/sdk';

/**
 * Тонкая обёртка над @twa-dev/sdk.
 * В деве (обычный браузер, не Telegram) многие поля недоступны —
 * везде подстраховываемся дефолтами, чтобы верстать локально без Telegram.
 */
export function initTelegramWebApp(): void {
  try {
    WebApp.ready();
    WebApp.expand();
    WebApp.setHeaderColor('#0b0d0f');
    WebApp.setBackgroundColor('#050607');
    WebApp.enableClosingConfirmation();
    // Отключаем системный свайп-вниз-для-закрытия — иначе Telegram иногда перехватывает
    // жесты внутри скроллящихся зон (например, горизонтальный список фильтров в лобби).
    // Доступно с Bot API 7.7 — оборачиваем в try, т.к. в старых клиентах метода нет.
    (WebApp as any).disableVerticalSwipes?.();
  } catch {
    // не в среде Telegram — просто пропускаем
  }
}

export function getInitData(): string {
  return WebApp.initData ?? '';
}

export function getTelegramUser() {
  return WebApp.initDataUnsafe?.user ?? null;
}

export function hapticImpact(style: 'light' | 'medium' | 'heavy' = 'light'): void {
  try {
    WebApp.HapticFeedback.impactOccurred(style);
  } catch {
    /* noop вне Telegram */
  }
}

export function hapticNotification(type: 'success' | 'error' | 'warning'): void {
  try {
    WebApp.HapticFeedback.notificationOccurred(type);
  } catch {
    /* noop */
  }
}

export function isInsideTelegram(): boolean {
  return Boolean((window as any).Telegram?.WebApp?.initData);
}
